module.exports = __webpack_public_path__ + "static/logo-blog-a5b95293bfe5c724c4536446ec8eaf92.svg";